import { z } from "zod/v4";

export const DataErrorsConst = {
  Integer: "Integer",
  Required: "Required",
  PostCode: "PostCode",
  City: "City",
  Country: "Country",
  MinLength: "MinLength",
  MaxLength: "MaxLength",
  Min: "Min",
  Max: "Max",
  Email: "Email",
  Telephone: "Telephone",
  Website: "Website",
  RemoveHttp: "RemoveHttp",
  MustBeAfter: "MustBeAfter",
  MustBeBefore: "MustBeBefore",
  MustBeChanged: "MustBeChanged",
  StreetAddress: "StreetAddress",
  ReturnDateRequired: "ReturnDateRequired",
} as const;

export type DataErrorsConstType = keyof typeof DataErrorsConst;

export type ErrorCode =
  | DataErrorsConstType
  | Readonly<Exclude<z.core.$ZodIssue["code"], "custom">>;

export type DataErrors<T> = Record<keyof T, DataErrorsConstType[]>;

export function ZodIssueToDatErrorsConstMapper(
  issue: z.core.$ZodIssue,
): ErrorCode {
  switch (issue.code) {
    case "custom": {
      return issue.message as DataErrorsConstType;
    }
    default:
      return issue.code;
  }
}
